// import Moment from 'moment'
// 全局过滤器
export default (Vue) => {
  /**
   * 制冷方式
   */
  Vue.filter('coldMethod', (method) => {
    switch (method) {
      case '1':
      case 1:
        return '风冷'
      default:
        return '风冷'
    }
  })

  /**
   * 识别方式
   */
  Vue.filter('recognition', (method) => {
    switch (method) {
      case '1':
      case 1:
        return '静态图像、动态视频'
      case '2':
      case 2:
        return '压力传感'
      case '3':
      case 3:
        return '图像、视频、压力传感、决策脑'
      default:
        return ''
    }
  })
}



// WEBPACK FOOTER //
// ./src/filters.js